import rest from "../script/rest";

class OverviewRest {

    async getTopViewImage(calculationId) {
        const url = "/rest/overview/getTopViewImage"
            + "?calculationId=" + calculationId;
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }

    async getSouthNordViewImage(calculationId) {
        const url = "/rest/overview/getSouthNordViewImage"
            + "?calculationId=" + calculationId;
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }

    async getEastWestViewImage(calculationId) {
        const url = "/rest/overview/getEastWestViewImage"
            + "?calculationId=" + calculationId;
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }

    async getFieldArray(calculationId) {
        const url = "/rest/overview/fieldArray"
            + "?calculationId=" + calculationId;
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }
}
const overviewRest = new OverviewRest();
window.overviewRest = overviewRest;
export default overviewRest;